module.exports = "#status-bar-save-button {\n  color: black;\n  font-size: 16px;\n  font-weight: 500; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/atoms/alg-header-button/alg-header-button.component.scss
// module id = ./src/app/components/atoms/alg-header-button/alg-header-button.component.scss
// module chunks = main